import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordViewerComponent } from './word-viewer.component';

@NgModule({
    declarations: [
        WordViewerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        WordViewerComponent
    ]
})
export class NcWordViewerModule { }